import React from "react";
import './Badge.css';

// 게시글 상태 배지 컴포넌트
const Badge = ({ type }) => {

    // 상태별 배지 정보
    const badgeInfo = {
        '습득': { text: '습득', colorClass: 'badge-found' },
        '분실': { text: '분실', colorClass: 'badge-lost' },
        '주인찾음': { text: '주인찾음', colorClass: 'badge-completed' },
    };

    // 잘못된 값이 들어왔을 경우 기본 배지 표시
    const currentBadge =
        badgeInfo[type] || { text: '확인중', colorClass: 'badge-unknown' };

    return (
        <span className={`badge ${currentBadge.colorClass}`}>
            {currentBadge.text}
        </span>
    );
};

export default Badge;